import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import { formatGraphqlErrors } from 'utils/helpers';
import { DeleteLoanConsultantDocument, LoanConsultantsDocument } from 'graphql/generated/graphql';

const useDeleteLoanConsultant = () => {
  const [deleteLoanConsultantMutation] = useMutation(DeleteLoanConsultantDocument);

  const handleDelete = useCallback(
    async (variables: { email: string }) => {
      try {
        await deleteLoanConsultantMutation({
          variables,
          refetchQueries: [{ query: LoanConsultantsDocument }],
          awaitRefetchQueries: true,
        });
      } catch (error) {
        throw formatGraphqlErrors(error);
      }
    },
    [deleteLoanConsultantMutation],
  );
  return handleDelete;
};

export default useDeleteLoanConsultant;
